<template>
  <div class="asc-mx-status-icon-label--container">
    <asc-mx-status-icon
      class="asc-mx-status-label--icon"
      :status-name="statusName"
    ></asc-mx-status-icon>
    <asc-mx-status-label
      class="asc-mx-status-label--title"
      :value="statusName"
    ></asc-mx-status-label>
  </div>
</template>

<script>
import AscMxStatusIcon from './AscMxStatusIcon'
import AscMxStatusLabel from './AscMxStatusLabel'

export default {
  name: 'AscErrorTypeIconLabel',

  components: {
    AscMxStatusIcon,
    AscMxStatusLabel,
  },

  props: {
    statusName: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.asc-mx-status-icon-label--container {
  display: flex;
  margin-top: -2px;

  & .asc-mx-status-label--title {
    flex: 1;
    min-width: 0;
    margin-left: 12px;
  }
}
</style>
